<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		stroke="currentColor"
		fill="none"
		stroke-width="1"
	>
		<g fill-rule="evenodd">
			<path
				d="m19.853 13.245 1.679 1.694a.75.75 0 0 1 .123.891l-1.622 2.928a.75.75 0 0 1-.87.355l-2.262-.675a7.754 7.754 0 0 1-1.966 1.156l-.585 2.438a.75.75 0 0 1-.73.576h-3.242a.75.75 0 0 1-.729-.576L9.042 19.5a7.775 7.775 0 0 1-1.795-1.106l-2.412.717a.75.75 0 0 1-.87-.355l-1.621-2.928a.75.75 0 0 1 .124-.892l1.861-1.874a8.272 8.272 0 0 1 0-2.12L2.468 9.066a.75.75 0 0 1-.124-.892l1.622-2.93a.75.75 0 0 1 .87-.355l2.412.72A7.776 7.776 0 0 1 9.04 4.503L9.65 1.97a.75.75 0 0 1 .73-.575h3.241a.75.75 0 0 1 .73.575l.586 2.441a7.754 7.754 0 0 1 1.967 1.156l2.26-.675c.338-.101.7.046.871.355l1.622 2.927a.75.75 0 0 1-.124.892l-1.679 1.692a8.511 8.511 0 0 1 0 2.487Z"
			></path>
			<path d="M12 14.617m0 1.5a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"></path>
		</g>
	</svg>
</div>
